import { InMemoryCache } from '@apollo/client';
import { GET_USERNAME } from 'graphqls/profile';

export const initializeSaveUsername = (cache: InMemoryCache): void => {
  cache.writeQuery({
    query: GET_USERNAME,
    data: { currentUsername: '' },
  });
};

export default {
  resolvers: {
    Mutation: {
      saveUsername: (_, { currentUsername }, { cache }): null => {
        cache.writeQuery({
          query: GET_USERNAME,
          data: {
            __typename: 'savedUsername',
            currentUsername,
          },
        });

        return currentUsername;
      },
    },
  },
};
